import { smartSalesApiUrl } from 'app.constants';
export const SmartSalesConstants = {
    CURRENT_SMART_SALES_VERSION: '3.2',
    SMART_SALES_VERSION_WITH_CTA: '3.0',
    SMART_SALES_VERSION_WITH_CTA_TOGGLE: '3.1',
    WA_CTA_ACTION_NAME: 'smartSalesWhatsappCta',
    WA_WEB_ACTION_NAME: 'smartSalesWebLinkEnabled',
    DEFAULT_DISABLED_CTA_ACTION_NAME: 'defaultDisabledCtaMsg',
    BLOCK_TYPE_FOR_TRACKING: 'Smart Sales',
    STATE_ID_PREFIX: 'smart-sales:',
    DEFAULT_BLOCK_TITLE: 'Smart Sales',
    SMART_SALES_PLUGIN_ID: '9eb3546e-fd7a-462c-8599-f4d6f1de708b',
    APPLICATION_NAME: 'Application',
    PLUGINS_NAME: 'Plugins',
    ROUTER_NAME: 'master',
    ROUTER_DOMAIN: '@msging.net',
    API_BASE_URL: smartSalesApiUrl,
    USER_RESPONSE_STATUS: {
        ACCEPT_TO_BUY: 'ACCEPT_TO_BUY',
        REFUSED_TO_BUY: 'REFUSED_TO_BUY',
        INACTIVITY: 'INACTIVITY',
        UNDEFINED: 'UNDEFINED',
    },
};
